var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg84(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00005 5.90898C4.88755 5.90898 4.7938 5.87148 4.70005 5.79648L0.387549 1.55898C0.218799 1.39023 0.218799 1.12773 0.387549 0.958985C0.556299 0.790235 0.818799 0.790235 0.987549 0.958985L5.00005 4.87773L9.01255 0.921484C9.1813 0.752734 9.4438 0.752734 9.61255 0.921484C9.7813 1.09023 9.7813 1.35273 9.61255 1.52148L5.30005 5.75898C5.2063 5.85273 5.11255 5.90898 5.00005 5.90898Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg84);
export default __webpack_public_path__ + "static/media/svg84.1039d3916938d59068d00696e095b6a7.svg";
export { ForwardRef as ReactComponent };